import normalizeUrl from "./normalizeUrl";

export default function postOpen(url: string, data: any, close: boolean) {
	const form = document.createElement('form');
	form.method = 'post';
	form.action = normalizeUrl(url);

	for (const name in data) {
		const input = document.createElement('input');
		input.type = 'hidden';
		input.name = name;
		input.value = data[name];
		form.appendChild(input);
	}

	const tmpWindow = window.open('', '_blank');
	if (tmpWindow) {
		tmpWindow.document.body.appendChild(form);
		form.submit();

		if (close) {
			tmpWindow.onload = function() {
				tmpWindow?.close();
			};
		}
	}
}